import { Images } from "@abcya/abcya_phaser";

export default class SnowLayer extends Phaser.GameObjects.Container
{
	constructor(scene, x, y)
	{
		super(scene);

        this.sceneX = x;
        this.sceneY = y;

        // const snow = {
        //     frame: ['Flake1', 'Flake2', 'Flake3'],
        //     lifespan: 8850,
        //     rotation: { value: 0, min: -2, max: 2 },
        //     accelerationX: { min: -0.5, max: 0.5 },
        //     accelerationY: { value: 0, control: [ { x: 0, y: 0 }, { x: 0.3, y: 0.15 }, { x: 0.9, y: 0.25 }, { x: 1, y: 0.5 } ] },
        //     scale: { min: 0.15, max: 0.5, control: [ { x: 0, y: 0 },{ x: 0.75, y: 0.75 }, { x: 1, y: 1 } ] }
        // };

        const snow = {
            frame: ['Flake1', 'Flake2', 'Flake3'],
            lifespan: 30000,
            //maxParticles: 50,
            frequency: 1000,
            quantity: {min: 5, max: 10},
            maxParticleScale: 0.6,
            minParticleScale: 0.2,
            speedY: {min: 30, max: 100},
            speedX: {min: -20, max: 20},
            //speed: {min: 20, max: 100},
            radial: true,
            //gravityY: 100,
            rotate: {start: 0, end: 180},
            angle: 90,
            y: -10,
            gravity: 0,
            scale: {min: .15, max: .2},
            x: {min: 0, max: 768},
            on: true,
            emitCallback: (particle, emitter)=>{
                emitter.rotate.end = Phaser.Math.RND.angle();
            }
        }

        const snow1 = {
            image: 'assetsheet',
            frame: ['Flake1', 'Flake2', 'Flake3'],
            lifespan: 5850,
            rotation: { value: 0, delta: { min: 0, max: 2 } },
            vx: { min: -0.2, max: 0.2 },
            vy:{ min: 10, max: 20 },
            scale: { min: 0.55, max: 1, control: [ { x: 0, y: 0 },{ x: 0.75, y: 0.75 }, { x: 1, y: 1 } ] }
        }

        const particle = this.scene.add.particles(Images.DEFAULT_ATLAS, 'Flake1');

        this.emitter = particle.createEmitter(snow);
    }

    startFill() {
        //this.emitter.emit('snow', [0, 768], [10,900], {total:50});
        const x = Phaser.Math.RND.between(0, 768);
        const y = Phaser.Math.RND.between(10, 900);
        //this.emitter.emitParticle(50, x, y);
    };
}
        
/*

    me.

    me.startBigFill = function() {
        this.emitter.emit('snow', [0, 768], [10,900], {total:250});
    };

})();*/